import React, { useContext, useEffect, useRef, useState } from "react";
import { AttributeContext } from "../AttributeContext";
import Utils from "../../../../Common/Utils";
import Label from "../../../Common/components/Label";
import { getAssociatedCategoriesByAttributeID } from "api/Attributes";
import {toast} from 'react-toastify'

const CategoriesView = () => {
  const { editingItem } = useContext(AttributeContext);

  const [loading, setLoading] = useState({
    status: "",
    message: "",
  });
  const [attValues, setAttValues] = useState(null);
  const [collapse, setCollapse] = useState(false);
  const attrId = useRef(null)

  useEffect(() => {
    setLoading({
      status: "",
      message: "",
      message2: "",
    });
  }, [editingItem.id]);

  const fetchCategoriesData = () => {
    attrId.current = editingItem.id
    setLoading({status: "Loading", message: "Loading..."})
    getAssociatedCategoriesByAttributeID(editingItem.id)
    .then((res) => {
      setAttValues(res)
      setLoading({
        status: "Success",
        message: ""
      })
    })
    .catch(err => {
      toast.error(err.message)
      setLoading({
        status: "Error",
        message: err.message
      })
    })
  }

  useEffect(() => {
    if(!collapse || attrId.current === editingItem.id) return 
    setAttValues(null)
    fetchCategoriesData()
  }, [collapse])

  function handle_collapse() {
    setCollapse(!collapse);
  }

  return (
    <>
      <div className="accordion" id="accordionFlushCat2">
        <div className="accordion-item border-0">
          <div
            className="accordion-button bg-white collapsed container-fluid"
            onClick={() => handle_collapse()}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#flush-collapseCat2"
            aria-controls="flush-collapseCat2"
            style={Utils.borderStyle()}

            //   style={{ border: "1px solid #d6d8d9" }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <Label message="Categories" />
            </div>
          </div>

          <div
            id="flush-collapseCat2"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingCat2"
            data-bs-parent="#accordionFlushCat2"
          >
            <div className="accordion-body p-0" style={{ minHeight: "30px" }}>
              { 
                loading.status === "Loading" && (
                  <div
                    className="alert alert-primary bg-white small p-2"
                    role="alert"
                  >
                    <span className="fas fa-circle-notch fa-spin" />
                    &nbsp;
                    <strong>{loading.message}</strong>
                  </div>
              )}

              { 
                loading.status === "Error" && (
                  <div
                    className="alert alert-danger small p-2"
                    role="alert"
                  >
                    <strong>{loading.message}</strong>
                  </div>
              )}

              {loading.status === "Success" && attValues &&  (
                <>
                  <div className="p-3" style={{ border: "1px solid #d6d8d9" }}>
                    {attValues && attValues.length > 0 ? (
                      <div>
                        {attValues.map((item, index) => {
                          return (
                            <div className="d-inline" key={index}>
                              <span
                                className="badge"
                                style={{
                                  fontSize: "0.75rem",
                                  backgroundColor: "#F2F2F2",
                                  marginBottom: "10px",
                                  color: "#5c5f62",
                                  fontFamily: "Noto Sans",
                                  fontWeight: "401",
                                  padding: "6px",
                                }}
                              >
                                {item.name}
                              </span>
                              &nbsp;&nbsp;
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div
                        className="alert alert-dark bg-white small p-2"
                        role="alert"
                      >
                        <strong>Category Not Found</strong>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CategoriesView;